import {
  BlockOutlined,
  DeleteOutlined,
  ExportOutlined,
  KeyOutlined,
  PlusOutlined,
  SafetyCertificateOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import { Button } from 'antd';
import { includes } from 'lodash';
import React, { useState } from 'react';
import { OPERATIONS, ROUTES } from '../../../common/constants';
import useRouter from '../../../hooks/useRouter';
import AddEnvModal from '../modals/AddEnvModal';
import AddKeyModal from '../modals/AddKeyModal';
import ConfirmDuplicateValuesModal from '../modals/ConfirmDuplicateValuesModal';
import ConfirmEmptyValuesModal from '../modals/ConfirmEmptyValuesModal';
import DeleteEnvModal from '../modals/DeleteEnvModal';
import DuplicateKeyValueModal from '../modals/DuplicateKeyValueModal';
import ExportEnvKeysModal from '../modals/ExportEnvModal';

export default function TableActions({
  setActionKey,
  selectedKeys,
  setTwoFAModalOpen,
  actionId,
  setActionId,
  actionKey,
  topicId,
  isEnvVerified,
  nullValueKeys,
  duplicateKeys,
  data,
  selectedProject,
  selectedProjectTopics,
  viewKeyValueModalOpen,
  sourceType,
  selectedTopics,
  refetchEnvKeyValueData,
  selectedRowKeys,
  envRecords,
  setSelectedRowKeys,
  selectedItemName,
  environmentRefetch,
}) {
  const { navigate } = useRouter();
  const [addEnvModalOpen, setAddEnvModalOpen] = useState(false);
  const [newKeyModalOpen, setNewKeyModalOpen] = useState(false);
  const [duplicateKeyModalOpen, setDuplicateKeyModalOpen] = useState(false);
  const [
    confirmEmptyValuesModalOpen,
    setConfirmEmptyValuesModalOpen,
  ] = useState(false);
  const [duplicateValuesModalOpen, setDuplicateValuesModalOpen] = useState(
    false,
  );
  const [exportEnvKeysModalOpen, setExportEnvKeysModalOpen] = useState(false);
  const [deleteEnvModalOpen, setDeleteEnvModalOpen] = useState(false);

  return (
    <div className="d-flex justify-between align-center p-16">
      <div className="d-flex gap-16">
        <Button
          onClick={() => setAddEnvModalOpen(true)}
          disabled={!topicId}
          type="primary"
        >
          <PlusOutlined /> Add ENV
        </Button>
        <Button
          type="primary"
          disabled={!topicId}
          onClick={() => {
            navigate(ROUTES.UPLOADKEYS, {
              state: {
                projectData: selectedProject,
                topicsId: selectedProjectTopics,
              },
            });
          }}
        >
          <UploadOutlined />
          Upload Keys
        </Button>
        <Button
          onClick={() => setNewKeyModalOpen(true)}
          disabled={!topicId}
          type="primary"
          className="d-flex align-center"
        >
          <KeyOutlined /> Add Key
        </Button>
        <Button
          onClick={() => setDuplicateKeyModalOpen(true)}
          disabled={
            selectedKeys?.length <= 0 ||
            data?.[0]?.environmentKeyValues?.length <= 1
          }
          type="primary"
          className="d-flex align-center"
        >
          <BlockOutlined /> Copy Value(s)
        </Button>
        <Button
          disabled={
            viewKeyValueModalOpen ||
            !actionId ||
            isEnvVerified ||
            includes(
              [OPERATIONS.DELETE_KEY, OPERATIONS.VIEW_PRIVATE_KEY],
              actionKey,
            ) ||
            data?.length <= 0
          }
          onClick={() => {
            setActionKey(OPERATIONS.VERIFY_ENV);
            if (nullValueKeys?.length > 0) {
              setConfirmEmptyValuesModalOpen(true);
            } else if (duplicateKeys?.length > 0) {
              setDuplicateValuesModalOpen(true);
            } else {
              setTwoFAModalOpen(true);
            }
          }}
          type="primary"
          className="d-flex align-center"
        >
          <SafetyCertificateOutlined /> Verify
        </Button>
        <Button
          type="primary"
          disabled={
            !actionId ||
            !isEnvVerified ||
            includes(
              [OPERATIONS.DELETE_KEY, OPERATIONS.VIEW_PRIVATE_KEY],
              actionKey,
            ) ||
            data?.length <= 0
          }
          className="d-flex align-center"
          onClick={() => {
            setActionKey(OPERATIONS.EXPORT_ENV);
            if (nullValueKeys?.length > 0) {
              setConfirmEmptyValuesModalOpen(true);
            } else if (duplicateKeys?.length > 0) {
              setDuplicateValuesModalOpen(true);
            } else {
              setExportEnvKeysModalOpen(true);
            }
          }}
        >
          <ExportOutlined /> Export
        </Button>
        <Button
          onClick={() => setDeleteEnvModalOpen(true)}
          disabled={
            viewKeyValueModalOpen ||
            !actionId ||
            includes(
              [OPERATIONS.DELETE_KEY, OPERATIONS.VIEW_PRIVATE_KEY],
              actionKey,
            )
          }
          type="primary"
          className="d-flex align-center"
          danger
        >
          <DeleteOutlined /> Delete ENV
        </Button>
        <Button
          type="primary"
          disabled={!topicId}
          onClick={() => {
            navigate(ROUTES.HISTORY, {
              state: {
                projectData: selectedProject,
                topicsId: selectedProjectTopics,
              },
            });
          }}
        >
          History
        </Button>
        <AddEnvModal
          visible={addEnvModalOpen}
          setVisible={setAddEnvModalOpen}
          sourceType={sourceType}
          selectedTopics={selectedTopics}
          selectedProjectTopics={selectedProjectTopics}
          selectedProject={selectedProject}
          refetchEnvKeyValueData={refetchEnvKeyValueData}
          environmentRefetch={environmentRefetch}
        />
        <AddKeyModal
          visible={newKeyModalOpen}
          setVisible={setNewKeyModalOpen}
          topicId={topicId}
          refetchEnvKeyValueData={refetchEnvKeyValueData}
        />
        <DuplicateKeyValueModal
          visible={duplicateKeyModalOpen}
          setVisible={setDuplicateKeyModalOpen}
          selectedKeys={selectedRowKeys}
          envRecords={envRecords}
          refetchEnvKeyValueData={refetchEnvKeyValueData}
          setSelectedRowKeys={setSelectedRowKeys}
        />
        <ConfirmEmptyValuesModal
          visible={confirmEmptyValuesModalOpen}
          setVisible={setConfirmEmptyValuesModalOpen}
          setTwoFaModalVisible={setTwoFAModalOpen}
          setActionId={setActionId}
          setActionKey={setActionKey}
          selectedItemName={selectedItemName}
          nullValueKeys={nullValueKeys}
          actionKey={actionKey}
          setExportEnvKeysModalOpen={setExportEnvKeysModalOpen}
          setDuplicateValuesModalOpen={setDuplicateValuesModalOpen}
          duplicateKeys={duplicateKeys}
        />
        <ConfirmDuplicateValuesModal
          visible={duplicateValuesModalOpen}
          setVisible={setDuplicateValuesModalOpen}
          setActionKey={setActionKey}
          setTwoFaModalVisible={setTwoFAModalOpen}
          setActionId={setActionId}
          selectedItemName={selectedItemName}
          actionKey={actionKey}
          setExportEnvKeysModalOpen={setExportEnvKeysModalOpen}
          duplicateKeys={duplicateKeys}
        />
        <ExportEnvKeysModal
          visible={exportEnvKeysModalOpen}
          setVisible={setExportEnvKeysModalOpen}
          setTwoFAModalOpen={setTwoFAModalOpen}
          selectedItemName={selectedItemName}
        />
        <DeleteEnvModal
          visible={deleteEnvModalOpen}
          setVisible={setDeleteEnvModalOpen}
          setTwoFAModalOpen={setTwoFAModalOpen}
          setActionKey={setActionKey}
          selectedItemName={selectedItemName}
        />
      </div>
      <div className="text-center">Logicwind © {new Date().getFullYear()}</div>
    </div>
  );
}
